"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_tags_1 = require("common-tags");
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var Chord = /** @class */ (function (_super) {
    __extends(Chord, _super);
    function Chord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chord.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_padAngle":
            case "_innerRadius":
                return utils_1.parseNumberWithAuto(value);
            case "_sortGroups":
            case "_sortSubgroups":
            case "_sortChords":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Chord.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _innerRadius: 0.9, _padAngle: 0.05, _sortGroups: d3.descending, _sortSubgroups: d3.descending, _sortChords: d3.descending });
    };
    Chord.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("arctip");
        this._groupRibbons = this.appendGroupT(_1.Component).data([])
            .options({
            _x: function (_) { return _this._outerRadius; },
            _y: function (_) { return _this._outerRadius; },
        });
        this._ribbons = this._groupRibbons.appendT(element_1.Ribbon).options({
            class: "ribbon",
            _radius: function (_) { return _this._innerRadius; },
            _source: function (d) { return d.source; },
            _target: function (d) { return d.target; },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._ribbons.dom)
                    .renderHTML(function (d) { return common_tags_1.oneLineTrim(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Source: Index: ", ",\n                                                           Subindex: ", ",\n                                                           Value: ", "\n                                                   <br>\n                                                   Target: Index: ", ",\n                                                           Subindex: ", ",\n                                                           Value: ", ""], ["Source: Index: ", ",\n                                                           Subindex: ", ",\n                                                           Value: ", "\n                                                   <br>\n                                                   Target: Index: ", ",\n                                                           Subindex: ", ",\n                                                           Value: ", ""])), d.source.index, d.source.subindex, d.source.value, d.target.index, d.target.subindex, d.target.value); });
            },
            _$mouseEnter: function (d, i, g) {
                var source = d.source.index;
                var target = d.target.index;
                d3.selectAll(".arc").style("opacity", function (_, k) { return (k === source || k === target) ? "1" : "0.2"; });
                g.forEach(function (_, j) { return g[j].style.opacity = (i === j) ? "1" : "0.2"; });
            },
            _$mouseLeave: function (_, i, g) {
                d3.selectAll(".arc").style("opacity", "1");
                g.forEach(function (_, j) { return g[j].style.opacity = "1"; });
            },
        });
        this._groupArcs = this.appendGroupT(_1.Component).data([])
            .options({
            _x: function (_) { return _this._outerRadius; },
            _y: function (_) { return _this._outerRadius; },
            _$mouseEnter: function (d, i, g) {
                var index = d.index;
                var targetIndex = [];
                d3.selectAll(".ribbon").style("opacity", function (d) {
                    targetIndex.push(d.target.index);
                    return index === d.source.index ? "1" : "0.2";
                });
                d3.selectAll(".arc")
                    .style("opacity", function (d, j) {
                    return g[j].style.opacity = (index === d.index || targetIndex.indexOf(d.index) !== -1) ? "1" : "0.2";
                });
            },
            _$mouseLeave: function (_, i, g) {
                d3.selectAll(".ribbon").style("opacity", "1");
                d3.selectAll(".arc")
                    .style("opacity", function (_, j) { return g[j].style.opacity = "1"; });
            },
        });
        this._arcs = this._groupArcs.appendT(element_1.Arc).options({
            class: "arc",
            _innerR: function (_) { return _this._innerRadius; },
            _outerR: function (_) { return _this._outerRadius; },
            _startAngle: function (d) { return d.startAngle / Math.PI * 180; },
            _endAngle: function (d) { return d.endAngle / Math.PI * 180; },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._arcs.dom)
                    .renderHTML(function (d) { return "Group: " + _this._labelData[d.index] + "<br>Value: " + d.value; });
            },
        });
        this._labels = this._groupArcs.appendT(element_1.Text).options({
            _x: function (d) { return Math.cos((d.startAngle + d.endAngle) / 2 - Math.PI / 2) * _this._outerRadius; },
            _y: function (d) { return Math.sin((d.startAngle + d.endAngle) / 2 - Math.PI / 2) * _this._outerRadius; },
            _text: function (d) { return _this._labelData[d.index]; },
            _anchor: this._getAnchor(),
        });
    };
    Chord.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this._outerRadius = Math.min(this._getGeometry("_height", false) / 2, this._getGeometry("_width", true) / 2);
        this._innerRadius = this.getOption("_innerRadius") * this._outerRadius;
        var chord = d3.chord()
            .padAngle(this.getOption("_padAngle"))
            .sortGroups(this.getOption("_sortGroups"))
            .sortSubgroups(this.getOption("_sortSubgroups"))
            .sortChords(this.getOption("_sortChords"));
        var matrixData = Object.values(this.datum);
        this._labelData = Object.keys(this.datum);
        var data = chord(matrixData);
        this._groupArcs.data(data.groups);
        this._groupRibbons.data(data);
        this.setupProxy({
            arc: "_arcs",
            ribbon: "_ribbons",
            label: "_labels",
        });
    };
    Chord.prototype._getAnchor = function () {
        var _this = this;
        return function (d) {
            var anchorX;
            var anchorY;
            var x = Math.cos((d.startAngle + d.endAngle) / 2 - Math.PI / 2) * _this._outerRadius;
            var y = Math.sin((d.startAngle + d.endAngle) / 2 - Math.PI / 2) * _this._outerRadius;
            if (Math.round(x) > 0) {
                anchorX = 16 /* Left */;
            }
            else if (Math.round(x) < 0) {
                anchorX = 64 /* Right */;
            }
            else {
                anchorX = 32 /* Center */;
            }
            if (Math.round(y) > 0) {
                anchorY = 2 /* Top */;
            }
            else if (Math.round(y) < 0) {
                anchorY = 8 /* Bottom */;
            }
            else {
                anchorY = 4 /* Middle */;
            }
            return anchorX | anchorY;
        };
    };
    return Chord;
}(_1.Component));
exports.Chord = Chord;
var templateObject_1;
//# sourceMappingURL=chord.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/chord.js
// module id = 1159
// module chunks = 0 1